import React, { useEffect, useState } from 'react';
import { USER_ROLES, showError, sortArray } from 'utils';
import { fetchUsersInRole } from 'services/api/users';

const UsersDropdown = props => {
  const [users, setUsers] = useState<Record<string, any>[]>([]);
  const [loading, setLoading] = useState(false);

  const {
    value,
    onChange,
    role = USER_ROLES.SALES_PERSON,
    title = 'Choose User',
    disabled,
  } = props;

  const fetchUsersInRoleFn = async () => {
    try {
      setLoading(true);
      const response = await fetchUsersInRole({ role });
      setUsers(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsersInRoleFn();
  }, []);
  
  const handleSelect = (id: string) => {
    onChange(id);
  };

  const getOptions = () => sortArray(users, 'full_name').map((row, i) => (
    <option key={i} value={row.objectId}>{row.full_name}</option>
  ));

  return (
    <>
      <select
        disabled={!users.length || loading || disabled}
        className={'form-control'}
        onChange={e => handleSelect(e.target.value)}
        value={value}
      >
        <option value=''>{title}</option>
        {users.length && getOptions()}
      </select>
    </>
  );
};

export default UsersDropdown;